export default "__VITE_ASSET__C2HI7OiX__"